import {
  useCurrentClientManager,
  useEntitiesThatCannotOnboardSubentities,
} from '@cko/dashboard-shared';
import { QueryKey, useQuery } from '@tanstack/react-query';
import settings from '../../../../services/app-settings';
import { ProcessingChannelVo, useProcessingChannelsFetcher } from './useProcessingChannelsFetcher';

export const useProcessingChannels = () => {
  const { client, entity } = useCurrentClientManager();
  const { id: clientId = null } = client || {};
  const { id: entityId = null } = entity || {};
  const entitiesWithChannelsToDisplay = useEntitiesThatCannotOnboardSubentities();
  const fetcher = useProcessingChannelsFetcher(entitiesWithChannelsToDisplay, 1);

  const queryKey: QueryKey = [
    `${settings.api.serverSideApiBasePath}/processing-channels`,
    {
      clientId,
      entityId,
    },
  ];

  return useQuery<ProcessingChannelVo[], Error>(
    queryKey,
    fetcher,
    {
      enabled: Boolean(clientId),
      cacheTime: 60 * 60 * 1000,
    }, // 1 hours cache
  );
};
